import {uploadBlob} from "../../lib/fileUploader";
import {sleep} from "../../lib/general";
import {responsevideoValid} from "../../lib/responsevideo";
import axios from 'axios'

export default {
  namespaced: true,
  state: {
    list : [],
    uploading : false,
    uploadProgress : {},
    currentUploadingId : null,
    localMap: {}
  },
  mutations: {
    setUploading(state,uploading){
      state.uploading=uploading;
    },
    addToQueue(state,responsevideo){
      state.list.push(responsevideo);
    },
    updateProgress(state,progress){
      state.uploadProgress=progress;
    },
    setCurrentUploadingId(state,currentUploadingId){
      state.currentUploadingId=currentUploadingId;
    },
    removeFromQueue(state,responsevideoid){
      const idx = state.list.findIndex((e)=>e.responsevideoid===responsevideoid);
      if(idx > -1){
        state.list.splice(idx);
      }
    },
    addToLocalMap(state,responsevideo){
      const temp=JSON.parse(JSON.stringify(state.localMap));
      temp[responsevideo.responsevideoid]=responsevideo.local;
      state.localMap=temp;
    }
  },
  actions: {
    async addVideoToUploadQueue({commit,dispatch, rootState, state},{responsevideo, otherResponsevideos}){
      return new Promise(((resolve,reject) => {
        const existing=state.list.find(rv=>rv.responsevideoid==responsevideo.responsevideoid);
        if(!existing && !responsevideoValid(responsevideo)){
          this.$http.get('responsevideos/'+responsevideo.responsevideoid).then(async (response)=>{
            const rv=response.data.data;
            if(!responsevideoValid(rv)){
              //First cancel other videos for the answer
              for (let otherRv of otherResponsevideos){
                if(otherRv.responsevideoid!==rv.responsevideoid){
                  if(state.currentUploadingId==otherRv.responsevideoid && window.lastVideoUploadSource){
                    window.lastVideoUploadSource.cancel();
                    commit('setUploading',false);
                  }
                  commit('removeFromQueue',otherRv.responsevideoid);
                }
              }
              commit('addToLocalMap',responsevideo);
              //Now queue this video
              commit('addToQueue',{
                responsevideoid:responsevideo.responsevideoid,
                personid:rootState.assessment.assessment.personid,
                assessmentid:rootState.assessment.assessment.assessmentid,
                local:responsevideo.local
              });
              dispatch('startQueueUploading');
              resolve(true);
            }else{
              resolve(false);
            }
          }).catch((e)=>reject(e));
        }else{
          resolve(false);
        }
      }));

    },
    async startQueueUploading({commit,state}){
      if(state.uploading) return;
      commit('setUploading',true);

      let idx=0;
      let errors=0;
      while(state.list.length>0 && idx<30 && state.uploading){

        if(window.lastVideoUploadSource){
          window.lastVideoUploadSource.cancel();
        }
        const rv = state.list[0];
        const videoUrl=state.localMap[rv.responsevideoid];

        if(!videoUrl){
          commit('removeFromQueue',rv.responsevideoid);
        }else{
          const videoBlob=await fetch(videoUrl).then(r => r.blob());
          const filename='localresponsevideos/rv_'+rv.responsevideoid+'.mkv';
          try{
            commit('updateProgress',null);
            const CancelToken = axios.CancelToken;
            window.lastVideoUploadSource = CancelToken.source();
            commit('setCurrentUploadingId',rv.responsevideoid);
            await uploadBlob(videoBlob,filename,(e)=>{
              //Progress
              commit('updateProgress',e);
            },window.lastVideoUploadSource);
            window.lastVideoUploadSource=null;
            commit('updateProgress',null);
            commit('setCurrentUploadingId',null);
            await this.$http.post('/responsevideos/'+rv.responsevideoid+'/attach',{filename});
            commit('removeFromQueue',rv.responsevideoid);

          }catch (e) {
            errors++;
            if(errors>30){
              commit('setUploading',false);
              return;
            }
            console.error(e);
            //If error put at the back
            commit('removeFromQueue',rv.responsevideoid);
            await sleep(3000);
          }
        }
        idx++;
      }
      commit('setUploading',false);
    },
    stopQueueUploading({commit}){
      if(window.lastVideoUploadSource){
        window.lastVideoUploadSource.cancel('Upload Cancelled');
      }
      commit('setUploading',false);
      commit('updateProgress',null);
    }
  },
  getters: {}
}